<a href="https://www.bestbuy.ca/">
    <img src="/assets/images/advertisements/bestBuy.png" class="mw-100 d-block mt-2 img-fluid" width="225" height="225">
</a>
<a href="http://hasspetroleum.com/">
    <img src="/assets/images/advertisements/hass.png" class="mw-100 d-block mt-2 img-fluid" width="225" height="225">
</a>
<a href="https://www.dahabshiil.com/">
    <img src="/assets/images/advertisements/dahabshiil.png" class="mw-100 d-block mt-2 img-fluid" width="225" height="225">
</a>
